import { Input } from "components";
import { formatAlphaOnly, formatCurrency, formatPhoneNumber } from "@compass/core";
import { ApplicationQuestion, FormQuestion } from "generated/openApi";
import { FormQuestionWriteInTypes } from "pages/cobro/surveys/SurveyPage/Questions/SurveyQuestionEnum";
import { TransientQuestionResponse } from "./TransientQuestionResponse";
import CurrencyInput from "react-currency-input-field";

export type OpenEndedQuestionProps = {
  question: ApplicationQuestion | FormQuestion;
  transientResponse: TransientQuestionResponse;
  updateQuestionResponse: (value: TransientQuestionResponse) => void;
  isDisabled?: boolean;
};

export const OpenEndedQuestion = ({
  question,
  transientResponse,
  updateQuestionResponse,
  isDisabled,
}: OpenEndedQuestionProps) => {
  const isFormQuestionCheck = (question: any): question is FormQuestion => {
    return (question as FormQuestion).formId !== undefined;
  };
  const isFormQuestion = isFormQuestionCheck(question);

  const currencyStyle = {
    color: "rgba(0, 0, 0, 0.87)",
    padding: "16.5px 14px",
    minWidth: `${isFormQuestion ? question.writeInWidthPercent || "100" : "100"}%`,
    borderRadius: "5px",
    borderWidth: "1.25px",
    borderStyle: "solid",
    borderColor: "rgba(0, 0, 0, 0.20)" 
  };

  return (
    <>
      {question.formQuestionWriteInTypeId != FormQuestionWriteInTypes.Currency && (
        <Input
          sx={{ maxWidth: `${isFormQuestion ? question.writeInWidthPercent || "100" : "100"}%` }}
          value={
            question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.Date
              ? transientResponse.writeInDate
              : question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.PhoneNumber
              ? formatPhoneNumber(transientResponse.writeIn)
              : question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.AlphaOnly 
              ? formatAlphaOnly(transientResponse.writeIn)
              : transientResponse.writeIn
          }
          required={question.isMandatory}
          disabled={isDisabled}
          multiline={question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.Textarea}
          type={
              question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.Number
              ? "number"
              : question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.Date && !isDisabled
              ? "date"
              : "text"
          }
          maxLength={question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.PhoneNumber ? 15 : undefined}
          onChange={(e) => {
            updateQuestionResponse({
              ...transientResponse,
              writeInDate: question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.Date ? e.target.value : null,
              writeIn: question.formQuestionWriteInTypeId != FormQuestionWriteInTypes.Date ? 
              question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.PhoneNumber ? formatPhoneNumber(e.target.value) || null
              : e.target.value 
              : null,
            });
          }}
        />
      )}
      {question.formQuestionWriteInTypeId == FormQuestionWriteInTypes.Currency && (
        <CurrencyInput
          style={currencyStyle}
          id={question.id.toString()}
          disabled={isDisabled}
          prefix="$"
          defaultValue={question.defaultAnswer || undefined}
          value={transientResponse.writeIn || undefined}
          decimalsLimit={2}
          onValueChange={(value, name, values) => {
            updateQuestionResponse({
              ...transientResponse,
              writeIn: value || null
            });
          }}
        />
      )}
    </>
  );
};
